export default function FullPageLoader({ text = "Please wait..." }) {
  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-white rounded-xl px-6 py-5 flex flex-col items-center gap-3 shadow-lg">
        <svg
          className="w-8 h-8 animate-spin text-blue-600"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>

        <p className="text-sm font-medium text-slate-700">{text}</p>
      </div>
    </div>
  );
}
